import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

interface ResultData {
  title: string;
  subtitle: string;
  description: string;
  services: { label: string; icon: string; desc: string }[];
  cta: string;
}

const RESULTS: Record<string, Record<string, ResultData>> = {
  q1_access: {
    q2_sales: {
      title: "SEO × ホームページ制作",
      subtitle: "検索から直接お問い合わせを獲得する仕組みを構築",
      description: "アクセスが増えない根本原因はSEO設計の不足です。検索上位に表示されるサイト構造と、訪問者を確実に問い合わせへ転換するUI設計を組み合わせることで、広告費ゼロで継続的な集客を実現します。",
      services: [
        { label: "ホームページ制作", icon: "ri-global-line", desc: "成果直結のサイト設計" },
        { label: "SEO対策", icon: "ri-search-line", desc: "検索上位表示の継続維持" },
        { label: "コンバージョン最適化", icon: "ri-line-chart-line", desc: "問い合わせ率の最大化" },
      ],
      cta: "SEO×制作の詳細を見る",
    },
    q2_awareness: {
      title: "SNS運用 × SEO",
      subtitle: "新しい層へのリーチと検索流入を同時に強化",
      description: "アクセス不足と認知拡大を同時に解決するには、SNSでの拡散力とSEOの継続集客を組み合わせるのが最短ルートです。ターゲット層が集まるプラットフォームで存在感を高めながら、検索からの流入も確保します。",
      services: [
        { label: "SNS運用", icon: "ri-instagram-line", desc: "認知拡大とエンゲージメント向上" },
        { label: "SEO対策", icon: "ri-search-line", desc: "検索流入の継続的な確保" },
        { label: "コンテンツ制作", icon: "ri-article-line", desc: "拡散されるコンテンツ設計" },
      ],
      cta: "SNS×SEOの詳細を見る",
    },
    q2_repeat: {
      title: "MEO × ホームページ制作",
      subtitle: "地域密着の集客基盤とリピート促進の仕組みを構築",
      description: "地域のお客様からのアクセスを増やしながら、リピーターを育てる仕組みを同時に整えます。Googleマップでの上位表示と、再来店を促すサイト設計で、安定した顧客基盤を作ります。",
      services: [
        { label: "MEO対策", icon: "ri-map-pin-line", desc: "Googleマップ上位表示" },
        { label: "ホームページ制作", icon: "ri-global-line", desc: "リピート促進のUI設計" },
        { label: "LINE活用支援", icon: "ri-message-line", desc: "顧客との継続的な接点" },
      ],
      cta: "MEO×制作の詳細を見る",
    },
    q2_brand: {
      title: "SEO × ブランディング制作",
      subtitle: "検索流入とブランド価値を同時に高める長期戦略",
      description: "アクセス不足とブランド確立を同時に解決するには、SEOとブランディングを一体で設計することが重要です。検索で見つけてもらいながら、訪問者に強い印象を残すサイトで信頼を積み上げます。",
      services: [
        { label: "SEO対策", icon: "ri-search-line", desc: "長期的な検索流入の確保" },
        { label: "ブランディング制作", icon: "ri-palette-line", desc: "一貫したブランドイメージ構築" },
        { label: "コンテンツ戦略", icon: "ri-article-line", desc: "専門性を示すコンテンツ設計" },
      ],
      cta: "ブランディング×SEOの詳細を見る",
    },
  },
  q1_cost: {
    q2_sales: {
      title: "SEO × MEO対策",
      subtitle: "広告費ゼロで問い合わせを増やす自然流入戦略",
      description: "広告費をかけずに集客するなら、SEOとMEOの組み合わせが最も費用対効果が高い選択です。一度上位表示されれば継続的に集客でき、長期的なコスト削減と売上増加を同時に実現します。",
      services: [
        { label: "SEO対策", icon: "ri-search-line", desc: "広告不要の継続集客" },
        { label: "MEO対策", icon: "ri-map-pin-line", desc: "地域検索からの無料集客" },
        { label: "ホームページ最適化", icon: "ri-global-line", desc: "既存サイトの改善" },
      ],
      cta: "低コスト集客の詳細を見る",
    },
    q2_awareness: {
      title: "SNS運用 × LLMO対策",
      subtitle: "低コストで最大限の認知拡大を実現",
      description: "限られた予算で認知を広げるには、SNSの有機的な拡散力とAI検索への最適化が最も効率的です。広告費をかけずにターゲット層へリーチし、AIに紹介されやすいコンテンツで新しい認知経路を開拓します。",
      services: [
        { label: "SNS運用", icon: "ri-instagram-line", desc: "有機的な認知拡大" },
        { label: "LLMO対策", icon: "ri-robot-line", desc: "AI検索への最適化" },
        { label: "コンテンツ制作", icon: "ri-article-line", desc: "拡散力の高いコンテンツ" },
      ],
      cta: "低コスト認知拡大の詳細を見る",
    },
    q2_repeat: {
      title: "MEO × LINE活用",
      subtitle: "低コストでリピーターを育てる地域密着戦略",
      description: "費用を抑えながらリピーターを増やすには、MEOで地域のお客様を集め、LINEで継続的な関係を築くのが最も効率的です。一度来店したお客様を確実にリピーターへ転換します。",
      services: [
        { label: "MEO対策", icon: "ri-map-pin-line", desc: "地域からの集客強化" },
        { label: "LINE活用支援", icon: "ri-message-line", desc: "低コストのリピート促進" },
        { label: "口コミ対策", icon: "ri-star-line", desc: "レビュー獲得の仕組み化" },
      ],
      cta: "低コストリピート戦略の詳細を見る",
    },
    q2_brand: {
      title: "ホームページ制作 × SEO",
      subtitle: "費用対効果の高いブランド構築と集客の両立",
      description: "限られた予算でブランドを確立するには、SEOで集客しながらサイトでブランドを伝える設計が最も効率的です。広告費をかけずに、検索から来た訪問者に強い印象を残します。",
      services: [
        { label: "ホームページ制作", icon: "ri-global-line", desc: "ブランドを伝えるサイト設計" },
        { label: "SEO対策", icon: "ri-search-line", desc: "広告不要の継続集客" },
        { label: "コンテンツ戦略", icon: "ri-article-line", desc: "専門性を示すコンテンツ" },
      ],
      cta: "費用対効果の高い戦略を見る",
    },
  },
  q1_design: {
    q2_sales: {
      title: "ホームページ制作 × CRO",
      subtitle: "ブランドイメージを刷新し、問い合わせ率を最大化",
      description: "古いデザインは信頼性を損ない、問い合わせ率を大きく下げています。最新のデザインとコンバージョン最適化を組み合わせることで、ブランドイメージの向上と売上増加を同時に実現します。",
      services: [
        { label: "ホームページ制作", icon: "ri-global-line", desc: "最新デザインへの全面刷新" },
        { label: "UI/UX最適化", icon: "ri-layout-line", desc: "問い合わせ率の最大化" },
        { label: "ブランディング", icon: "ri-palette-line", desc: "一貫したビジュアル設計" },
      ],
      cta: "デザイン刷新の詳細を見る",
    },
    q2_awareness: {
      title: "ホームページ制作 × SNS運用",
      subtitle: "刷新したブランドを新しい層へ広く届ける",
      description: "デザインを刷新したら、そのブランドイメージをSNSで積極的に発信することで認知拡大の効果が最大化されます。新しいビジュアルアイデンティティを武器に、新規層へのリーチを一気に広げます。",
      services: [
        { label: "ホームページ制作", icon: "ri-global-line", desc: "ブランドイメージの全面刷新" },
        { label: "SNS運用", icon: "ri-instagram-line", desc: "新しいブランドの認知拡大" },
        { label: "ビジュアル制作", icon: "ri-image-line", desc: "統一されたクリエイティブ" },
      ],
      cta: "ブランド刷新×認知拡大の詳細を見る",
    },
    q2_repeat: {
      title: "ホームページ制作 × CRM",
      subtitle: "信頼されるブランドでリピーターを育てる",
      description: "古いデザインはリピーターの離脱原因にもなります。ブランドイメージを刷新し、既存顧客が誇りを持って紹介できるサイトに生まれ変わることで、リピート率と口コミを同時に向上させます。",
      services: [
        { label: "ホームページ制作", icon: "ri-global-line", desc: "信頼感のあるデザイン刷新" },
        { label: "顧客体験設計", icon: "ri-user-heart-line", desc: "リピートを促すUX" },
        { label: "ブランディング", icon: "ri-palette-line", desc: "一貫したブランド体験" },
      ],
      cta: "ブランド刷新の詳細を見る",
    },
    q2_brand: {
      title: "ブランディング × ホームページ制作",
      subtitle: "長期的な信頼を築くブランドの全面刷新",
      description: "ブランドの確立には、デザインだけでなくメッセージ・世界観・顧客体験の全てを一貫して設計することが重要です。長期的な視点でブランドを構築し、業界での確固たるポジションを確立します。",
      services: [
        { label: "ブランディング戦略", icon: "ri-palette-line", desc: "ブランドの根本から再設計" },
        { label: "ホームページ制作", icon: "ri-global-line", desc: "ブランドを体現するサイト" },
        { label: "コンテンツ戦略", icon: "ri-article-line", desc: "ブランドストーリーの発信" },
      ],
      cta: "ブランディングの詳細を見る",
    },
  },
  q1_unknown: {
    q2_sales: {
      title: "無料診断 × 総合サポート",
      subtitle: "まず現状を把握し、最短で売上につながる施策を特定",
      description: "何から始めればいいかわからない状態でも大丈夫です。まず現状のサイト・集客・競合を無料で診断し、あなたのビジネスに最も効果的な施策を優先順位付きでご提案します。",
      services: [
        { label: "無料サイト診断", icon: "ri-search-eye-line", desc: "現状の課題を可視化" },
        { label: "競合分析", icon: "ri-bar-chart-line", desc: "勝てる戦略の特定" },
        { label: "施策ロードマップ", icon: "ri-road-map-line", desc: "優先順位付きの実行計画" },
      ],
      cta: "まず無料診断を受ける",
    },
    q2_awareness: {
      title: "無料診断 × 認知拡大戦略",
      subtitle: "現状を把握してから、最も効果的な認知拡大施策を選択",
      description: "認知拡大の手段は多岐にわたりますが、ビジネスの状況によって最適解は異なります。まず現状を診断し、あなたのターゲット層に最も効果的にリーチできる施策を特定します。",
      services: [
        { label: "無料サイト診断", icon: "ri-search-eye-line", desc: "現状の課題を可視化" },
        { label: "ターゲット分析", icon: "ri-user-search-line", desc: "最適なチャネルの特定" },
        { label: "認知拡大ロードマップ", icon: "ri-road-map-line", desc: "段階的な認知拡大計画" },
      ],
      cta: "まず無料診断を受ける",
    },
    q2_repeat: {
      title: "無料診断 × リピート戦略",
      subtitle: "現状を把握してから、リピーターを育てる仕組みを構築",
      description: "リピーターを増やすための施策は、現在の顧客接点や業種によって大きく異なります。まず現状を診断し、あなたのビジネスに最適なリピート促進の仕組みを設計します。",
      services: [
        { label: "無料サイト診断", icon: "ri-search-eye-line", desc: "現状の課題を可視化" },
        { label: "顧客体験分析", icon: "ri-user-heart-line", desc: "リピート阻害要因の特定" },
        { label: "リピート戦略設計", icon: "ri-road-map-line", desc: "継続的な関係構築の仕組み" },
      ],
      cta: "まず無料診断を受ける",
    },
    q2_brand: {
      title: "無料診断 × ブランド戦略",
      subtitle: "現状を把握してから、長期的なブランド構築を開始",
      description: "ブランディングは長期的な取り組みですが、まず現状のブランド認知と競合ポジションを把握することが重要です。診断結果をもとに、あなたのビジネスに最適なブランド戦略を設計します。",
      services: [
        { label: "無料サイト診断", icon: "ri-search-eye-line", desc: "現状のブランド評価" },
        { label: "競合ポジション分析", icon: "ri-bar-chart-line", desc: "差別化ポイントの特定" },
        { label: "ブランド戦略設計", icon: "ri-palette-line", desc: "長期的なブランド計画" },
      ],
      cta: "まず無料診断を受ける",
    },
  },
};

interface DiagnosisResultProps {
  q1: string;
  q2: string;
  onRetry: () => void;
  isDark?: boolean;
}

function ServiceCard({ svc, i, visible, isDark, onClick }: {
  svc: { label: string; icon: string; desc: string };
  i: number;
  visible: boolean;
  isDark: boolean;
  onClick?: () => void;
}) {
  const [pressed, setPressed] = useState(false);
  return (
    <button
      onClick={onClick}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setTimeout(() => setPressed(false), 200)}
      className="w-full flex items-center gap-3 p-4 text-left cursor-pointer active:scale-[0.98]"
      style={{
        border: `1px solid ${pressed ? "#c00000" : (isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)")}`,
        background: pressed
          ? (isDark ? "rgba(192,0,0,0.15)" : "rgba(192,0,0,0.06)")
          : (isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)"),
        opacity: visible ? 1 : 0,
        transform: visible ? "translateX(0)" : "translateX(-24px)",
        transition: `opacity 0.55s ease ${0.2 + i * 0.1}s, transform 0.5s cubic-bezier(0.22,1,0.36,1) ${0.2 + i * 0.1}s, border 0.2s ease, background 0.2s ease`,
        position: "relative",
        overflow: "hidden",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      {/* Left accent bar */}
      <div style={{
        position: "absolute",
        left: 0, top: 0, bottom: 0,
        width: "3px",
        background: "#c00000",
        transform: pressed ? "scaleY(1)" : "scaleY(0)",
        transformOrigin: "top",
        transition: "transform 0.25s cubic-bezier(0.22,1,0.36,1)",
      }} />

      {/* Icon box */}
      <div
        className="w-10 h-10 flex items-center justify-center shrink-0"
        style={{
          background: pressed ? "#c00000" : (isDark ? "rgba(192,0,0,0.8)" : "#111111"),
          transition: "background 0.2s ease",
        }}
      >
        <i className={`${svc.icon} text-sm text-white`} />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{
          fontFamily: "'Noto Sans JP', sans-serif",
          fontSize: "14px",
          fontWeight: 700,
          color: pressed ? "#c00000" : (isDark ? "#ffffff" : "#111111"),
          transition: "color 0.2s ease",
        }}>
          {svc.label}
        </p>
        <p style={{
          fontFamily: "'Noto Sans JP', sans-serif",
          fontSize: "12px",
          color: isDark ? "rgba(255,255,255,0.5)" : "#111111",
          marginTop: "2px",
        }}>
          {svc.desc}
        </p>
      </div>

      <i className="ri-arrow-right-line ml-auto shrink-0" style={{ color: "#c00000", fontSize: "16px" }} />
    </button>
  );
}

export default function DiagnosisResult({ q1, q2, onRetry, isDark = false }: DiagnosisResultProps) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [lineWidth, setLineWidth] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setVisible(true), 80);
    const t2 = setTimeout(() => setLineWidth(100), 300);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const result = RESULTS[q1]?.[q2] ?? RESULTS["q1_unknown"]["q2_sales"];

  return (
    <div>
      {/* Result badge — animated line */}
      <div className="flex items-center gap-3 mb-8">
        <div
          className="px-4 py-1.5"
          style={{
            background: "#c00000",
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(-12px)",
            transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.22,1,0.36,1)",
          }}
        >
          <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.35em", color: "#ffffff", fontWeight: 500 }}>
            DIAGNOSIS RESULT
          </span>
        </div>
        <div style={{ flex: 1, height: "1px", background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)", overflow: "hidden" }}>
          <div style={{
            height: "100%",
            background: "#c00000",
            width: `${lineWidth}%`,
            transition: "width 0.9s cubic-bezier(0.22,1,0.36,1) 0.2s",
          }} />
        </div>
      </div>

      {/* Main result */}
      <div className="mb-10">
        <p
          className="mb-3"
          style={{
            fontFamily: "'Barlow', sans-serif", fontSize: "11px", letterSpacing: "0.4em", color: "#c00000",
            opacity: visible ? 1 : 0,
            transition: "opacity 0.5s ease 0.1s",
          }}
        >
          RECOMMENDED SOLUTION
        </p>
        <h2
          className="mb-3"
          style={{
            fontFamily: "'Noto Sans JP', sans-serif",
            fontSize: "clamp(18px, 5vw, 36px)",
            fontWeight: 700,
            color: isDark ? "#ffffff" : "#111111",
            lineHeight: 1.3,
            letterSpacing: "0.03em",
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease 0.15s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0.15s",
          }}
        >
          {result.title}
        </h2>
        <p
          className="mb-6"
          style={{
            fontFamily: "'Noto Sans JP', sans-serif", fontSize: "14px", color: "#c00000", fontWeight: 500,
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 0.6s ease 0.22s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0.22s",
          }}
        >
          {result.subtitle}
        </p>
        <div style={{ height: "1px", background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.12)", marginBottom: "24px",
          transform: `scaleX(${visible ? 1 : 0})`, transformOrigin: "left",
          transition: "transform 0.7s cubic-bezier(0.22,1,0.36,1) 0.3s",
        }} />
        <p
          style={{
            fontFamily: "'Noto Sans JP', sans-serif", fontSize: "14px",
            color: isDark ? "rgba(255,255,255,0.75)" : "#111111", lineHeight: 1.8,
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(12px)",
            transition: "opacity 0.6s ease 0.35s, transform 0.6s cubic-bezier(0.22,1,0.36,1) 0.35s",
          }}
        >
          {result.description}
        </p>
      </div>

      {/* Recommended services */}
      <div className="mb-10">
        <p
          className="mb-5"
          style={{
            fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.35em",
            color: isDark ? "rgba(255,255,255,0.3)" : "#111111",
            opacity: visible ? 1 : 0,
            transition: "opacity 0.5s ease 0.3s",
          }}
        >
          RECOMMENDED SERVICES
        </p>
        <div className="flex flex-col gap-3">
          {result.services.map((svc, i) => (
            <ServiceCard key={i} svc={svc} i={i} visible={visible} isDark={isDark} onClick={() => navigate("/service")} />
          ))}
        </div>
      </div>

      {/* CTA */}
      <div
        className="p-5 md:p-8 mb-6 md:mb-8"
        style={{
          background: isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
          border: isDark ? "1px solid rgba(255,255,255,0.1)" : "1px solid rgba(0,0,0,0.12)",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(24px)",
          transition: "opacity 0.7s ease 0.55s, transform 0.7s cubic-bezier(0.22,1,0.36,1) 0.55s",
        }}
      >
        <p className="mb-2" style={{ fontFamily: "'Barlow', sans-serif", fontSize: "10px", letterSpacing: "0.35em", color: isDark ? "rgba(255,255,255,0.4)" : "#111111" }}>
          NEXT STEP
        </p>
        <h3 className="mb-2" style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "17px", fontWeight: 700, color: isDark ? "#ffffff" : "#111111", lineHeight: 1.5 }}>
          まずは無料相談から始めましょう
        </h3>
        <p className="mb-5" style={{ fontFamily: "'Noto Sans JP', sans-serif", fontSize: "12px", color: isDark ? "rgba(255,255,255,0.5)" : "#111111", lineHeight: 1.9 }}>
          診断結果をもとに、あなたのビジネスに最適なプランを詳しくご提案します。
          オンライン対応・完全無料・押し売り一切なし。
        </p>
        <button
          onClick={() => navigate("/contact")}
          className="w-full flex items-center justify-center gap-3 py-4 cursor-pointer whitespace-nowrap active:scale-95 transition-all duration-200"
          style={{ background: "#c00000", color: "#ffffff", fontFamily: "'Noto Sans JP', sans-serif", fontSize: "14px", fontWeight: 700, letterSpacing: "0.06em", border: "none", WebkitTapHighlightColor: "transparent" }}
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = "#c00000"; }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = "#c00000"; }}
        >
          無料相談を予約する
          <i className="ri-arrow-right-line text-sm" />
        </button>
      </div>

      {/* Retry */}
      <div
        className="flex justify-center"
        style={{
          opacity: visible ? 1 : 0,
          transition: "opacity 0.6s ease 0.7s",
        }}
      >
        <button
          onClick={onRetry}
          className="flex items-center gap-2 cursor-pointer transition-colors duration-300"
          style={{ background: "none", border: "none", padding: 0, fontFamily: "'Noto Sans JP', sans-serif", fontSize: "13px", color: isDark ? "rgba(255,255,255,0.3)" : "#111111" }}
          onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.color = isDark ? "#ffffff" : "#111111"; }}
          onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.color = isDark ? "rgba(255,255,255,0.3)" : "#111111"; }}
        >
          <i className="ri-refresh-line text-sm" />
          もう一度診断する
        </button>
      </div>
    </div>
  );
}
